import { render, staticRenderFns } from "./AccountRecoveryForm.vue?vue&type=template&id=5e808590"
import script from "./AccountRecoveryForm.vue?vue&type=script&lang=js"
export * from "./AccountRecoveryForm.vue?vue&type=script&lang=js"
import style0 from "./AccountRecoveryForm.vue?vue&type=style&index=0&id=5e808590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports